import { isObjEmpty } from '../helpers/isObjEmpty';
import { Form } from './Form';

export class FormWithValidation extends Form {
  validation = {};
  errors = {};
  handlers = { onErrorStatusChange: null };

  constructor(fields, validation, handlers = {}) {
    super(fields);
    this.validation = validation;
    this.handlers = handlers;
  }

  _setError(fieldName, value) {
    this.errors[fieldName] = value;
  }

  _removeError(fieldName) {
    delete this.errors[fieldName];
  }

  getError(fieldName) {
    return this.errors[fieldName] ?? null;
  }

  reset() {
    super.reset();
    this.validation = {};
    this.errors = {};
  }

  validateOne(fieldName) {
    const fieldRules = this.validation[fieldName];
    let hasError = false;

    for (const ruleName in fieldRules) {
      const rule = fieldRules[ruleName];
      const curr = this.fields[fieldName];

      if (hasError) {
        continue;
      }

      hasError = ![
        rule.test && !rule.test(curr),
        ruleName === 'minLength' && curr.length < rule.value,
        ruleName === 'maxLength' && curr.length > rule.value,
        ruleName === 'isRequired' && rule.value === true && !curr,
      ].every((flag) => !flag);

      if (hasError) {
        this._setError(fieldName, rule.errorText);
      } else {
        this._removeError(fieldName);
      }
    }

    return {
      hasErrors: this.hasErrors,
      hasError,
      errorText: this.errors[fieldName],
    };
  }

  validateAll() {
    Object.keys(this.validation).forEach((fieldName) => {
      this.validateOne(fieldName);
    });
    return this.hasErrors;
  }

  get hasErrors() {
    const value = !isObjEmpty(this.errors);
    this.handlers.onErrorStatusChange?.(value);
    return value;
  }
}
